import { render } from "./Media.vue?vue&type=template&id=3731dd8b&scoped=true&lang=pug"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=3731dd8b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3731dd8b"]])

export default __exports__